
<template>
  <div>
    <v-select
      v-model="selected"
      :items="items"
      item-value="uid"
      item-text="name"
      chips
      :loading="loading"
      :label="label"
      multiple
      outlined
      :clearable="clearable"
      :disabled="disabled"
    ></v-select>
  </div>
</template>

<script>
export default {
  name: "PortalsSelect",
  components: {},
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    label: {
      type: String,
      default: "Veranstalter",
    },
    hint: {
      type: String,
      default: null,
    },
    value: {
      type: Array,
      required: false,
    },
  },
  data: function () {
    return {
      ownChangeEvent: false,
      loading: false,
      items: [],
      selected: null,
    };
  },
  computed: {},
  watch: {
    value: function (val) {
      if ((this.selected && !val) || (!this.selected && val)) {
        this.ownChangeEvent = true;
        this.selected = val;
        this.ownChangeEvent = false;
        return;
      }
      if (this.selected && val && this.selected.place_id != val.place_id) {
        this.ownChangeEvent = true;
        this.selected = val;
        this.ownChangeEvent = false;
        return;
      }
      // console.log('Ignoring new value')
    },
    selected: function () {
      if (!this.ownChangeEvent) {
        this.$emit("input", this.selected);
      }
    },
  },
  mounted() {
    this.ownChangeEvent = true;
    this.selected = this.value;
    this.ownChangeEvent = false;
    this.refreshPortals();
  },
  methods: {
    refreshPortals: function() {
      this.loading = true;
      this.$api
        .getUsersAdminPortals().then((res) => {
          this.loading = false;
          this.items = res.data.list;
        })
        .catch(error => {
          this.loading = false;
          this.$common.onError(error)
        })
    }
  },
};
</script>